import { render, staticRenderFns } from "./QueryKumquatI.vue?vue&type=template&id=5069cdfc&"
import script from "./QueryKumquatI.vue?vue&type=script&lang=js&"
export * from "./QueryKumquatI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports